import styled from '@emotion/styled';
import { Icon } from './Icon';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  value: string;
  onChange: (value: string) => void;
  options: readonly SelectOption[];
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

const SelectContainer = styled.div`
  position: relative;
  width: 100%;
`;

const StyledSelect = styled.select`
  width: 100%;
  height: 48px;
  padding: ${(props) => props.theme.spacing(1.5)} ${(props) => props.theme.spacing(6)} ${(props) => props.theme.spacing(1.5)} ${(props) => props.theme.spacing(2)};
  border: 1px solid ${(props) => props.theme.colors.neutral.greyDark[800]};
  border-radius: ${(props) => props.theme.shape.borderRadiusLarge};
  background: transparent;
  color: ${(props) => props.theme.colors.neutral.white};
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: ${(props) => props.theme.typography.body3Regular.fontSize};
  font-weight: ${(props) => props.theme.typography.body3Regular.fontWeight};
  outline: none;
  appearance: none;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  option {
    background: ${(props) => props.theme.colors.tertiary[1000]};
    color: ${(props) => props.theme.colors.neutral.white};
    padding: ${(props) => props.theme.spacing(1)};
  }

  &::placeholder {
    color: ${(props) => props.theme.colors.text.disabled};
  }
`;

const IconWrapper = styled.div`
  position: absolute;
  right: ${(props) => props.theme.spacing(2)};
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Select = ({
  value,
  onChange,
  options,
  placeholder = 'Selecciona una opción',
  disabled = false,
  className,
}: SelectProps) => {
  return (
    <SelectContainer className={className}>
      <StyledSelect
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </StyledSelect>
      <IconWrapper>
        <Icon name="caret-down" color="white" size={24} />
      </IconWrapper>
    </SelectContainer>
  );
};
